<template>
  <div class="home">
    <Banner v-if="accountlengkap && !syaratketentuan"/>
    <BestHit v-if="accountlengkap && !syaratketentuan"/>
    <BlocBestHit v-if="accountlengkap && !syaratketentuan"/>
    <v-row>
      <v-col cols="12" lg="6">
        <LengkapiAkun class="ma-8" v-if="!accountlengkap"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="12" class="ma-4">
        <div>
          <SyaratKetentuan v-if="syaratketentuan"/>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import Banner from '@/components/Banner'
import BestHit from '@/components/BestHit'
import BlocBestHit from '@/components/BlocBestHit'
import { mapActions, mapState } from 'vuex'
import LengkapiAkun from '@/components/LengkapiAkun'
import SyaratKetentuan from '@/views/SyaratKetentuan'
export default {
  name: 'Home',
  components: {
    SyaratKetentuan,
    LengkapiAkun,
    BlocBestHit,
    BestHit,
    Banner
  },
  mounted () {
    this.getCategory()
  },
  computed: {
    ...mapState('authentication', ['user', 'accountlengkap', 'syaratketentuan'])
  },
  methods: {
    ...mapActions('ProductStore', ['getCategory'])
  }
}
</script>
